<template>
  <aside
      class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-2 bg-gradient-dark"
      id="sidenav-main"
      style="z-index: var(--z-sidebar, 50000);"
   data-layer="sidebar">
    <div class="sidenav-header" style="max-height: 40px">
      <i
          class="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
          @click="toggleSidebar"
          aria-hidden="true"
          id="iconSidenav"
      ></i>
    </div>

    <div class="sb-school-block" v-if="shortDisplayName || schoolName" @click="toggleSchoolSwitcher" :class="{'sb-school-clickable': userSchools.length > 1}" :title="userSchools.length > 1 ? 'Click to switch school' : ''">
      <div class="sb-school-logo" v-if="schoolLogo">
        <img :src="schoolLogo" alt="" @error="schoolLogo = null" />
      </div>
      <div class="sb-school-logo sb-school-logo-fallback" v-else>
        <span>{{ schoolInitials }}</span>
      </div>
      <div class="sb-school-info">
        <div class="sb-school-short" :title="shortDisplayName || schoolName">{{ shortDisplayName || schoolName }}</div>
        <div class="sb-school-full" v-if="shortDisplayName && schoolName && shortDisplayName !== schoolName" :title="schoolName">{{ schoolName }}</div>
      </div>
      <svg v-if="userSchools.length > 1" class="sb-switch-caret" :class="{open: showSchoolSwitcher}" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
    </div>
    <div class="sb-school-block" v-else>
      <div class="sb-school-logo sb-school-logo-fallback"><span class="sb-school-skel-circle"></span></div>
      <div class="sb-school-info">
        <div class="sb-school-skel" style="width:70%"></div>
        <div class="sb-school-skel" style="width:50%;margin-top:5px"></div>
      </div>
    </div>

    <div class="sb-switcher" v-if="showSchoolSwitcher && otherSchools.length > 0">
      <div class="sb-switcher-list">
        <div v-for="s in otherSchools" :key="s" class="sb-switcher-item" @click="switchSchool(s)">
          <span class="sb-switcher-dot"></span>
          <span class="sb-switcher-name">{{ s }}</span>
        </div>
      </div>
    </div>

    <div id="schoolsalowedbuild" style="display:none !important;"></div>

    <div class="sb-school-divider"></div>

    <div class="collapse navbar-collapse w-auto h-auto" id="sidenav-collapse-main">
      <ul class="navbar-nav">

        <!-- ═══ ADMIN-ONLY SECTION ═══ -->
        <li class="nav-item">
          <router-link :to="{ name: 'Home' }" custom v-slot="{ navigate }">
            <a href="#" @click.prevent="onNavClick(navigate)"
               :class="{ 'sb-active': $route.name === 'Home' }"
               class="sb-item">
              <span class="sb-ico"><span class="mdi mdi-home"></span></span>
              <span class="sb-txt">Home</span>
            </a>
          </router-link>
        </li>

        <li class="nav-item" v-if="isAdmin">
          <router-link :to="{ name: 'ExamDash' }" custom v-slot="{ navigate }">
            <a href="#" @click.prevent="onNavClick(navigate)"
               :class="{ 'sb-active': $route.name === 'ExamDash' }"
               class="sb-item">
              <span class="sb-ico"><span class="mdi mdi-view-dashboard"></span></span>
              <span class="sb-txt">Dashboard</span>
            </a>
          </router-link>
        </li>

        <li class="nav-item" v-if="isAdmin"><div class="sb-section">Exams</div></li>

        <li class="nav-item" v-if="isAdmin">
          <router-link :to="{ name: 'Exams' }" custom v-slot="{ navigate }">
            <a href="#" @click.prevent="onNavClick(navigate)"
               :class="{ 'sb-active': $route.name === 'Exams' }"
               class="sb-item">
              <span class="sb-ico"><span class="mdi mdi-chart-line"></span></span>
              <span class="sb-txt">Exams</span>
            </a>
          </router-link>
        </li>

        <li class="nav-item" v-if="isAdmin">
          <router-link :to="{ name: 'ExamResultsSend' }" custom v-slot="{ navigate }">
            <a href="#" @click.prevent="onNavClick(navigate)"
               :class="{ 'sb-active': $route.name === 'ExamResultsSend' }"
               class="sb-item">
              <span class="sb-ico"><span class="mdi mdi-message-text"></span></span>
              <span class="sb-txt">Send exam results</span>
            </a>
          </router-link>
        </li>

        <!-- ═══ TEACHER + ADMIN SECTION ═══ -->
        <li class="nav-item"><div class="sb-section">My teaching</div></li>

        <li class="nav-item">
          <router-link :to="{ name: 'MySubjects' }" custom v-slot="{ navigate }">
            <a href="#" @click.prevent="onNavClick(navigate)"
               :class="{ 'sb-active': ($route.name === 'MySubjects' || $route.name === 'MyExams') }"
               class="sb-item">
              <span class="sb-ico"><span class="mdi mdi-book-open-page-variant"></span></span>
              <span class="sb-txt">My subjects</span>
            </a>
          </router-link>
        </li>

        <!-- ═══ ADMIN-ONLY: SETTINGS SUBMENU (collapsible) ═══ -->
        <li class="nav-item" v-if="isAdmin">
          <a href="javascript:;" class="sb-item"
             :class="{
              'sb-parent-open': openMenu === 'settings',
              'sb-child-active': isChildActive('settings') && openMenu !== 'settings'
            }"
             @click="toggle('settings')"
             @keydown.enter.prevent="toggle('settings')"
             @keydown.space.prevent="toggle('settings')"
             tabindex="0" role="button" :aria-expanded="openMenu === 'settings'">
            <span class="sb-ico"><span class="mdi mdi-cog"></span></span>
            <span class="sb-txt">Settings</span>
            <svg class="sb-arr" :class="{ 'sb-arr-open': openMenu === 'settings' }" width="12" height="12" viewBox="0 0 12 12">
              <polyline points="2,4 6,8 10,4" fill="none" stroke="rgba(255,255,255,0.8)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          <div class="sb-sub-wrap" ref="settings">
            <div class="sb-sub-inner">
              <router-link v-for="(child, i) in settingsItems" :key="child.route"
                           :to="{ name: child.route }" custom v-slot="{ navigate }">
                <div @click="onNavClick(navigate)"
                     class="sb-child"
                     :class="{ 'sb-child-on': $route.name === child.route }"
                     :style="{ transitionDelay: openMenu === 'settings' ? (i * 40) + 'ms' : '0ms' }">
                  <span class="sb-dot"></span>
                  <span class="sb-ctxt">{{ child.label }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </li>

      </ul>
    </div>
  </aside>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import { mapMutations } from "vuex";
import apiService from '@/apis/apiService';
import { isAcademicsAdmin } from '@/composables/roles';
import { performSchoolSwitch } from '@/composables/schoolSwitch';

// Every route listed here is auto-opening for the "settings" submenu
// when visited directly. Keep in sync with the settingsItems array below.
const menuChildren = {
  settings: [
    "AcademicsSettings", "SchoolStamp",
    "Grades", "Subjects", "SubjectGroups", "ExamCategories",
    "Remarks", "GradingSystem", "RequiredSubs",
    "ReportDates", "ReportColours",
  ],
};

const routeMenuMap = {};
Object.keys(menuChildren).forEach((menu) => {
  menuChildren[menu].forEach((route) => {
    routeMenuMap[route] = menu;
  });
});

export default {
  name: "AcademicsSidebar",

  data() {
    return {
      openMenu: null,

      schoolName: localStorage.getItem('schoolName') || '',
      shortDisplayName: localStorage.getItem('shortDisplayName') || '',
      schoolLogo: localStorage.getItem('schoolLogo') || null,
      userSchools: [],
      activeSchoolName: localStorage.getItem('mainschoolname') || '',
      showSchoolSwitcher: false,
      switchingSchool: false,

      // Settings submenu — order matters for display.
      // "Academics settings" and "School stamp" are the two new top entries,
      // placed first because they're whole-school config rather than
      // per-entity lists.
      settingsItems: [
        { route: "AcademicsSettings", label: "Academics settings" },
        { route: "SchoolStamp",       label: "School stamp" },
        { route: "Grades",            label: "Grades" },
        { route: "Subjects",          label: "Subjects" },
        { route: "SubjectGroups",     label: "Subject groups" },
        { route: "ExamCategories",    label: "Exam categories" },
        { route: "Remarks",           label: "Remarks" },
        { route: "GradingSystem",     label: "Grading system" },
        { route: "RequiredSubs",      label: "Required subjects" },
        { route: "ReportDates",       label: "Report dates" },
        { route: "ReportColours",     label: "Report colours" },
      ],
    };
  },

  computed: {
    isAdmin() {
      return isAcademicsAdmin();
    },
    schoolInitials() {
      const name = this.shortDisplayName || this.schoolName || '';
      if (!name) return '?';
      const words = name.trim().split(/\s+/).filter(Boolean);
      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    otherSchools() {
      return this.userSchools.filter(s => s !== this.activeSchoolName);
    },
  },

  watch: {
    "$route.name"(newRoute) {
      const menu = routeMenuMap[newRoute];
      if (menu && menu !== this.openMenu) {
        this.toggle(menu);
      }
    },
  },

  mounted() {
    const container = document.getElementById("sidenav-main");
    if (container) new PerfectScrollbar(container);

    this.loadSchoolName();
    this.loadUserSchools();

    this.openMenu = routeMenuMap[this.$route.name] || null;
    this.$nextTick(() => {
      if (this.openMenu && this.$refs[this.openMenu]) {
        this.$refs[this.openMenu].style.maxHeight =
            this.$refs[this.openMenu].scrollHeight + "px";
      }
    });
  },

  methods: {
    ...mapMutations(["navbarMinimize"]),

    toggleSidebar() { this.navbarMinimize(); },

    onNavClick(navigate) {
      navigate();
      if (window.innerWidth < 1200) {
        this.$nextTick(() => this.navbarMinimize());
      }
    },

    async loadSchoolName() {
      if (this.shortDisplayName && this.shortDisplayName.trim().length > 0) return;
      if (this.schoolName && this.schoolName.trim().length > 0) return;
      try {
        const res = await apiService.apiClient.get('/api/v1/finance/transactions/school-info');
        const data = res.data;
        const fullName  = data.schoolName || data.Schoolname || '';
        const shortName = data.shortDisplayName || data.shortdisplayname || '';
        const logo      = data.logo || '';
        if (fullName)  { this.schoolName = fullName;  localStorage.setItem('schoolName', fullName); }
        if (shortName) { this.shortDisplayName = shortName; localStorage.setItem('shortDisplayName', shortName); }
        if (logo) { this.schoolLogo = logo; localStorage.setItem('schoolLogo', logo); }
      } catch (e) { /* ignore */ }
    },

    async loadUserSchools() {
      try {
        const res = await apiService.apiClient.get('/api/index/getUserSchools');
        let data = res.data;
        if (typeof data === 'string') { try { data = JSON.parse(data); } catch(e) {
          console.log(e)
        } }
        if (Array.isArray(data) && data.length > 0) data = data[0];
        let schoolsStr = data.userSchools || '[]';
        let schools = typeof schoolsStr === 'string' ? JSON.parse(schoolsStr.replace(/'/g, '"')) : schoolsStr;
        if (Array.isArray(schools) && schools.length > 0) {
          this.activeSchoolName = schools[0];
          localStorage.setItem('mainschoolname', schools[0]);
          this.userSchools = schools;
        }
      } catch (e) { /* ignore */ }
    },

    toggleSchoolSwitcher() {
      if (this.userSchools.length <= 1) return;
      this.showSchoolSwitcher = !this.showSchoolSwitcher;
    },

    async switchSchool(schoolName) {
      if (this.switchingSchool) return;
      this.switchingSchool = true;
      this.showSchoolSwitcher = false;
      try { await performSchoolSwitch(schoolName); }
      finally { this.switchingSchool = false; }
    },

    toggle(menu) {
      if (this.openMenu && this.$refs[this.openMenu]) {
        this.$refs[this.openMenu].style.maxHeight = "0px";
      }
      if (this.openMenu === menu) {
        this.openMenu = null;
        return;
      }
      this.openMenu = menu;
      this.$nextTick(() => {
        if (this.$refs[menu]) {
          this.$refs[menu].style.maxHeight =
              this.$refs[menu].scrollHeight + "px";
        }
      });
    },

    isChildActive(menu) {
      const children = menuChildren[menu];
      return children && children.includes(this.$route.name);
    },
  },
};
</script>

<style src="@/assets/css/sidebar.css"></style>
